import { render, staticRenderFns } from "./Addtenant.vue?vue&type=template&id=66785d4a&scoped=true"
import script from "./Addtenant.vue?vue&type=script&lang=js"
export * from "./Addtenant.vue?vue&type=script&lang=js"
import style0 from "./Addtenant.vue?vue&type=style&index=0&id=66785d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66785d4a",
  null
  
)

export default component.exports